import "../tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "video-editor",
    templateId: "video-editor-template",

    update: function (element, context) {},

    bind: function (component) {
      var $rootElement = jQuery(this.element),
        $previewElement = $rootElement.find(".preview");

      $rootElement.on("dragenter", ".preview", function (event) {
        event.preventDefault();
        jQuery(this).addClass("drag-over");
      });

      $rootElement.on("dragleave", ".preview", function (event) {
        jQuery(this).removeClass("drag-over");
      });

      $rootElement.on("dragend", ".preview", function (event) {
        jQuery(this).removeClass("drag-end");
      });

      $rootElement.on(
        "drop",
        ".preview",
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          var newFile = event.originalEvent.dataTransfer.files[0];

          Sparkle.PageBuilder.uploadAsset(newFile).done(
            function (data) {
              var asset = component.context;
              var result = data.asset;

              asset.id = data.asset.id;
              asset.url = result.url;
              asset.poster_image_path = result.poster_image_path;

              component.save(asset);
              component.render();
              this.render();
            }.bind(this),
          );
        }.bind(this),
      );

      $rootElement.on(
        "click",
        ".preview",
        function () {
          var initialValue = component.context;
          var attributeConfig = this.component.config.attributes[this.component.name] || {};
          var placeholder = attributeConfig.placeholder;

          var dialog = new Sparkle.PageBuilder.VideoDialog(
            initialValue,
            function (value) {
              component.save(value);
              component.render();
              this.render();
            }.bind(this),
            { placeholders: placeholder },
          );
        }.bind(this),
      );
    },

    unbind: function (element) {
      var $element = jQuery(this.element);

      $element.off("dragover");
      $element.off("dragout");
      $element.off("dragend");
      $element.off("drop");
      $element.off("click");
    },
  });
})();
